/**
 * Backend reachability, shared outside React so the fetch layer can publish it.
 *
 * Deliberately not a context: the only writer is FetchProvider's response
 * interceptor, which runs outside the component tree, and the only readers are
 * a banner and anything else that wants to warn before a user loses work.
 */
export type ConnectionStatus = "online" | "degraded";

let status: ConnectionStatus = "online";

const listeners = new Set<() => void>();

export const getConnectionStatus = (): ConnectionStatus => status;

export const subscribeConnectionStatus = (listener: () => void) => {
	listeners.add(listener);

	return () => {
		listeners.delete(listener);
	};
};

export const setConnectionStatus = (next: ConnectionStatus) => {
	if (next === status) return;

	status = next;
	listeners.forEach((listener) => listener());
};
